import {useMemo, useRef, useState} from "react";
import {useLocation, useParams} from "react-router";
import {useQuery} from "@tanstack/react-query";
import {Template} from "../../../components/template/template.jsx";
import {Card} from "../../../components/card/card.jsx";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";
import NoDataContent from "../../../components/reports/report-menu/no-data-content.jsx";
import CitizenHistoryInfoService from "../../../services/reports/citizen-history-info-service.js";
import Content from "./components/content.jsx";

export default function CitizenHistoryInfo() {
    const {id} = useParams();
    const {search} = useLocation();
    const [headerSelected, setHeaderSelected] = useState(-1);
    const [isPrinting, setIsPrinting] = useState(false);
    const printComponentRef = useRef(null);
    const filters = useMemo(() => Object.fromEntries([...new URLSearchParams(search)].filter(([, value]) => value)), [search]);

    const {data: reportData, isLoading} = useQuery({
        queryKey: ["citizen-history-info", id, filters],
        queryFn: () => CitizenHistoryInfoService.getCitizenHistory(id, filters),
        enabled: !!id,
    });

    const history = reportData?.history ?? [];
    const hasData = history.length > 0;
    const title = reportData?.citizen?.name
        ? `Histórico - ${reportData.citizen.name}`
        : "Histórico";

    return (
        <Template isLoading={isLoading || isPrinting}>
            <Template.Header>
                <Template.Title>{title}</Template.Title>
                <HeaderButtons
                    printable={true}
                    headerChange={true}
                    printComponentRef={printComponentRef}
                    reportData={reportData}
                    data={hasData}
                    headerSelected={headerSelected}
                    setHeaderSelected={setHeaderSelected}
                />
            </Template.Header>
            <Template.Body className="pl-0!">
                <Card className="w-full p-[0]!">
                    <Card.Body>
                        <NoDataContent reportData={reportData} data={hasData}/>
                        <Content
                            reportData={{...reportData, history}}
                            data={hasData}
                            entity={headerSelected}
                            title={title}
                            printComponentRef={printComponentRef}
                            setIsPrinting={setIsPrinting}
                            filters={filters}
                        />
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
}
